module.exports = __webpack_public_path__ + "img/editora.755cbfa8.png";